<div *ngFor="let alert of alerts" class="{{ cssClass(alert) }}" role="alert">
  <a class="agr--alert__close" (click)="removeAlert(alert)">&times;</a>
  <span [innerHTML]="alert.message"></span>
</div>
